import { resolveApiBaseUrl } from '../constants';

export function apiFetch(baseUrl, path, options = {}) {
  const url = `${resolveApiBaseUrl(baseUrl)}${path}`;
  return fetch(url, options);
}

